import { useState } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { FilterSaveFavoriteButton } from 'shared/mui/Filter/FilterButtons/FilterSaveFavoriteButton/FilterSaveFavoriteButton';
import {
  FilterSaveFavoriteDialog,
  FilterSaveFavoriteDialogFormValues,
} from 'shared/mui/Filter/FilterSaveFavoriteDialog/FilterSaveFavoriteDialog';

import { useFavoriteFilters } from './hooks/useFavoriteFilters';

export type FilterSaveFavoriteProps = {
  disabled?: boolean;
};

export const FilterSaveFavorite: React.FC<FilterSaveFavoriteProps> = ({ disabled }) => {
  const translate = useTypedTranslate();

  const notify = useNotify();

  const [open, setOpen] = useState(false);
  const form = useFormContext();

  const { setFavouriteFilters } = useFavoriteFilters();

  const onSubmit = (values: FilterSaveFavoriteDialogFormValues) => {
    setFavouriteFilters({
      name: values?.name,
      favorite: values.favorite,
      period: values?.period,
      values: form.getValues(),
    });

    notify(translate('app.filter.presetCreated', { name: values?.name }), {
      type: 'success',
    });
  };

  return (
    <>
      <FilterSaveFavoriteButton
        disabled={disabled}
        onClick={() => {
          setOpen(true);
        }}
      />
      <FilterSaveFavoriteDialog
        onClose={() => {
          setOpen(false);
        }}
        onSubmit={onSubmit as any}
        open={open}
      />
    </>
  );
};
